export const osnGridViewIcon = {
  // eslint-disable-next-line max-len
  data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="13" y="13" width="6" height="6" rx="1" fill="currentColor"/><rect x="5" y="13" width="6" height="6" rx="1" fill="currentColor"/><rect x="13" y="5" width="6" height="6" rx="1" fill="currentColor"/><rect x="5" y="5" width="6" height="6" rx="1" fill="currentColor"/></svg>`,
  name: 'grid-view',
};
